export function SET_ALERT_TYPE(state, payload) {
  state.config = { ...payload };
}
